import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import PropTypes from 'prop-types';

import classes from './Calendar.module.scss';
import { DaysRow } from '../DaysRow/DaysRow';
import { TimeRow } from '../TimeRow/TimeRow';

const Calendar = ({ activeCalendar }) => {
  return (
    <Surface className={classes.calendar}>
      <DaysRow />
      {activeCalendar.map(([time, schedules]) => (
        <TimeRow time={time} schedules={schedules} key={time} />
      ))}
    </Surface>
  );
};

Calendar.propTypes = {
  activeCalendar: PropTypes.array,
};

export { Calendar };
